<template>
  <v-row>
    <v-col>
      <GenericCard class="py-5 px-8 attention-box__call-actions">
        <BasicButton
          :block="false"
          large
          color="success"
          text="Llamar siguiente"
          icon-orientation="left"
          icon="mdi-phone-forward"
          :loading="loadingBtnCall"
          @click="callNextCustomer"
          :disabled="disabledCallCustomer"
        />
      </GenericCard>
    </v-col>
  </v-row>
</template>

<script>
import { getNextCustomer, existCustomersToCall } from '@/domain/box/box.model';
import { ticketStatuses } from '@/domain/global.enum';
import GenericCard from '@/infrastructure/vue/components/common/cards/GenericCard';
import BasicButton from '@/infrastructure/vue/components/common/buttons/BasicButton';

export default {
  name: 'ActionContainer',
  components: {
    GenericCard,
    BasicButton,
  },
  props: {
    ticketList: { type: Array, default: () => [] },
    assignmentDetail: { type: Object, default: () => {} },
    user: { type: Object, default: () => {} },
  },
  computed: {
    disabledCallCustomer() {
      return !existCustomersToCall(this.ticketList);
    },
  },
  data: () => ({
    loadingBtnCall: false,
  }),
  methods: {
    async callNextCustomer() {
      const nextCustomer = getNextCustomer(
        this.ticketList,
        this.assignmentDetail.boxCode
      );
      this.loadingBtnCall = true;
      const responseUpdateTicket = await this.$store.dispatch(
        'box/updateTicketAction',
        {
          ...nextCustomer,
          attentionType: this.user.attentionType,
          headquartersCode: this.user.headquartersCode,
          headquartersShort: this.user.headquartersShort,
          attentionTicketStatus: ticketStatuses.CALLING,
          boxCode: this.assignmentDetail.boxCode,
          attentionTicketCode:
            nextCustomer && nextCustomer.attentionTicketCode
              ? nextCustomer.attentionTicketCode
              : this.ticketList[0].attentionTicketCode,
        }
      );
      this.loadingBtnCall = false;
      this.$emit(
        'openAttendCustomerModal',
        responseUpdateTicket ? nextCustomer : false
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.attention-box {
  &__call-actions {
    margin: 50px 0 30px;
  }
}
</style>
